<template>
  <div>
    <loader v-show="loading"></loader>
    <vuetable
      :hasSlot="true"
      v-show="!loading"
      v-on:table-edit-request="handleEdit"
      v-on:table-delete-request="handleDelete"
      v-on:table-clone-request="clone"
      :showEdit="true"
      :showClone="true"
      :showDelete="true"
      :tableData="results"
      tableTitle="Lookup Profiles"
      :fields="[
        { header: 'Service Provider', prop: profile => profile.serviceProvider !== null ? profile.serviceProvider.name : '' },
        { header: 'Service Contract', prop: 'serviceContract' },
        { header: 'Description', prop: 'description' },
        { header: 'Address', prop: profile => profile.serviceProvider !== null && profile.serviceProvider.address !== null ? displayLocation(profile.serviceProvider.address) : '' }
      ]"
    >
    </vuetable>
  </div>
</template>
<script>
  import { decryptQueryString, createRouteIdHash } from '../../helpers/RouteHash'
  import Vuetable from '../../helpers/VueTable'
  import Loader from '../../helpers/Loader.vue'
  import API from '../../../api/endpoints'
  export default {
    name: 'RateAssistSearchResults',
    data () {
      return {
        loading: true,
        results: []
      }
    },
    components: {
      Vuetable,
      Loader
    },
    methods: {
      displayLocation (location) {
        let str = ''
        if (location.address) {
          str += location.address
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      handleDelete ({ item, index }) {
        this.$http.delete(API.DELETE_ADMIN_ENTITY('lookup-profile', item.id))
        .then(res => this.getResults())
        .catch(err => console.log(err))
      },
      handleEdit ({ item, index }) {
        this.$router.push({ name: 'RateAssist - View/Update Profile', params: { id: createRouteIdHash(item.id) } })
      },
      clone ({item}) {
        this.$router.push({ name: 'RateAssist - Clone a Profile', params: { id: createRouteIdHash(item.id) } })
      },
      getResults () {
        this.loading = true
        let url = ''
        if (this.queryString.hasOwnProperty('serviceProvider')) {
          url = API.GET_ENTITIES('lookup-profile')
        } else {
          url = API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('lookup-profile')
        }
        console.log(url)
        this.$http.get(url, { params: this.queryString, headers: { 'X-Lazy-Fetch': '0' } }).then(({data}) => {
          this.results = data
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.log(err)
        })
      }
    },
    watch: {
      '$route' (newVal, oldVal) {
        this.getResults()
      }
    },
    computed: {
      queryString () {
        let qs = decryptQueryString(this.$route.query)
        let like = {}
        for (let prop in qs) {
          like[prop] = `${qs[prop]}`
        }
        return like
      }
    },
    mounted () {
      this.getResults()
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/modules/rateassist/components/RateAssistSearchResults.vue